import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ticketEffects } from 'src/app/root-store/ticket-store/effects';
import { reducer, ticketStoreFeatureKey } from 'src/app/root-store/ticket-store/ticket-store.reducers';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(ticketStoreFeatureKey, reducer),
        EffectsModule.forFeature(ticketEffects)
    ]
})
export class TicketStoreModule {}
